import { FaRegCheckCircle } from 'react-icons/fa';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface HotelApprovalStatusProps {
  isError: boolean;
}

export const Card = styled.div`
  background: ${({ theme }) => theme.dataCardHotels.background};
  min-height: 242px;
  border-radius: 16px;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.dataCardHotels.shadow};
  overflow: hidden;
  cursor: pointer;

  margin: 0 16px 16px;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 0 0 16px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 50%;
  overflow: hidden;
  border-bottom: 1px solid ${({ theme }) => theme.dataCardHotels.border};

  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50% auto;
    background-image: url('/images/logo-rappi-travel4business.svg');
    z-index: 0;
  }
`;

export const CardContent = styled.div`
  padding: 16px;
`;

export const CardRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const CardHeaderLabel = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  width: 114px;
  height: 22px;
  top: 19px;
  right: 15px;
  border-radius: 87px;
  background: ${({ theme }) => theme.dataCardHotels.gradient};
`;

export const LabelText = styled.span`
  font-size: 10px;
  margin: 0 5px 0 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: ${({ theme }) => theme.dataCardHotels.labelTextColor};
`;

export const HotelApprovalStatus = styled.span<HotelApprovalStatusProps>`
  font-size: 12px;
  line-height: 1.5;
  text-align: right;
  min-width: fit-content;
  min-height: 18px;

  color: ${({ isError }) => (isError ? ColorPalette.HEX.RedRYB : ColorPalette.HEX.GreenPantone)};
`;

export const HotelTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${({ theme }) => theme.dataCardHotels.hotelTitle};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
`;

export const HotelSubtitle = styled.span`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
`;

export const CardFooter = styled.div`
  height: 20%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;

export const CardFooterPrice = styled.span`
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  width: 200px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
`;

export const CardFooterFullPrice = styled.span`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: right;
  color: ${ColorPalette.HEX.DimGray};
  min-width: fit-content;
`;

export const CheckCircleIcon = styled(FaRegCheckCircle)`
  font-size: 11px;
  color: ${({ theme }) => theme.dataCardHotels.icon} !important;
`;
